var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconBusiness = function SvgIconBusiness(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "icon-business_svg__a",
    width: 20,
    height: 20,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M0 0h20v20H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon-business_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#5E6574",
    d: "M3.5 17c-.413 0-.766-.147-1.06-.44A1.445 1.445 0 0 1 2 15.5v-9c0-.412.147-.766.44-1.06.294-.293.647-.44 1.06-.44H6V3.496c0-.414.147-.767.44-1.058A1.45 1.45 0 0 1 7.5 2h5c.412 0 .766.147 1.06.44.293.294.44.647.44 1.06V5h2.5c.413 0 .766.147 1.06.44.293.294.44.647.44 1.06v9c0 .412-.147.766-.44 1.06-.294.293-.647.44-1.06.44h-13Zm4-12h5V3.5h-5V5Zm9 7.25h-4v1c0 .213-.072.39-.216.534a.726.726 0 0 1-.534.216h-3.5a.726.726 0 0 1-.534-.216.726.726 0 0 1-.216-.534v-1h-4v3.25h13v-3.25ZM9 12.5h2v-2H9v2Zm-5.5-1.75h4v-1c0-.213.072-.39.216-.534A.726.726 0 0 1 8.25 9h3.5c.213 0 .39.072.534.216a.726.726 0 0 1 .216.534v1h4V6.5h-13v4.25Z"
  }))));
};
export default SvgIconBusiness;